import React, { useContext } from "react";
import { defineMessages } from "react-intl";
import { OutlinedButton } from "../../../components/button/Buttons.js";
import "../../../components/button/EditButton.js";
import "../../../components/modal/BulkModalContent.js";
import { BulkModalContext } from "../../../components/modal/BulkModalProvider.js";
import "@mui/material";
import "../../../components/modal/ModalButtons.js";
import "../../../components/modal/Modal.style.js";
import "../../../components/error/ErrorAccordion.js";
import "../../../components/error/ErrorDetails.js";
import "../../../components/error/localize.js";
import "../../../components/error/ErrorModal.js";
import "../../../components/error/GlobalServerErrorMessage.js";
import "../../../components/icons/Icon.js";
import "../../../components/icons/ExpandMoreIcon.js";
import "@opentelemetry/api";
import "../../../otel/TraceProvider.js";
import "react-error-boundary";
import "rxjs/operators";
import "@opentelemetry/context-zone";
import "@opentelemetry/exporter-trace-otlp-http";
import "@opentelemetry/instrumentation";
import "@opentelemetry/instrumentation-document-load";
import "@opentelemetry/instrumentation-xml-http-request";
import "@opentelemetry/resources";
import "@opentelemetry/sdk-trace-web";
import "@opentelemetry/semantic-conventions";
import "../../../components/modal/types.js";
import "../../../components/modal/ActionConfirmationModal.js";
import { FeatureAccessStatus } from "../../../contract/pam.js";
import "../../bulk-operation/actions.js";
import { BulkActionButton } from "../../bulk-operation/components/BulkActionButton.js";
import "../../bulk-operation/epics.js";
import { useBulkAction } from "../../bulk-operation/hooks.js";
import "../../bulk-operation/reducers.js";
import "../../bulk-operation/selectors.js";
import "rxjs";
import "../../../api/types.js";
import "immer";
import "moment-timezone";
import "@apollo/client/errors";
import "@apollo/client";
import "graphql";
import "@apollo/client/link/subscriptions";
import "@apollo/client/utilities";
import "cross-fetch";
import "graphql-ws";
import "../../../node_modules/moment/dist/moment.js";
import "rxjs/ajax";
import "../../bulk-operation/components/BulkExecutionStepDetailsContent.js";
import "../../bulk-operation/components/BulkExecutionStepModal.js";
import "../../bulk-operation/components/BulkSummaryStepActionItem.js";
import "../../bulk-operation/components/BulkSummaryStepHoc.js";
import "../../../components/chip/ChipRenderer.js";
import "../../../components/chip/Chips.js";
import "../../../components/chip/ListWithChipTooltip.js";
import "../../../components/chip/SquaredChipList.js";
import "../../bulk-operation/components/DataGrid.js";
import "../../bulk-operation/components/BulkStepValidationSummary.js";
import "../../../components/progress/CircularProgress.js";
import "../../../components/progress/CircularProgressWithLabel.js";
import "../../bulk-operation/components/BulkSummaryStepActionLabel.js";
import "@automapper/core";
import "../../p2p-player-settings/components/PlayerGlobalSettingsLink.js";
import "../../p2p-player-settings/components/PlayerGlobalSettings.js";
import { useP2PPlayerSettings } from "../../p2p-player-settings/hooks.js";
import "date-fns";
import "../../user-profile/constants.js";
import { useUserProfileDetails } from "../../user-profile/hooks.js";
import "typesafe-actions";
import "normalizr";
import "redux-observable";
import "../../../redux-folder/async-action/action.js";
import "../../../redux-folder/error-handling/action.js";
import "../../../redux-folder/actions.js";
import "fast-deep-equal/es6";
import "redux";
import "../../../redux-folder/entity/epics.js";
import "../../../redux-folder/entity/EntityProvider.js";
import { extendedViewCleanDelay } from "../../../redux-folder/view/types.js";
import "reselect";
import "react-redux";
import "react-router";
import "../../../redux-folder/realtime/RealtimeNotification.js";
import "../../user-profile/epics.js";
import "../../user-profile/actions.js";
import "../../user-profile/components/DataGrid.js";
import "../../user-profile/components/Platform.js";
import "../../../components/download/DownloadCsvButton.js";
import "../../../components/download/DownloadTemplate.js";
import "../../../auto-mapper/AutoMapperProvider.js";
import "../../../components/filter/FilterGroupNew.js";
import "../../../components/input/validation.js";
import "../../../components/input/DatePicker.js";
import "../../../components/input/DateRangePicker.js";
import "../../../components/input/StyledInput.js";
import "../../../components/input/FormInput.js";
import "../../../components/input/StyledFormInputHoc.js";
import "../../../components/input/DateSinglePicker.localize.js";
import "../../../components/input/hooks.js";
import "../../../components/filter/dateRangeFilter/DateRangeFilter.js";
import "../../../components/filter/date-filter/DateFilter.js";
import "../../../components/filter/TextFilterWithDropdown.js";
import "../../../components/filter/MultiStepFilterDrawer.js";
import "../../../components/filter/dateRangeFilter/MultiStepFilterDatePicker.js";
import "../../../components/select/Select.js";
import "../../../components/filter/TextFilter.js";
import "../../../components/filter/valueRangeFilter/ValueRangeFilter.js";
import "../../../components/filter/dateRangeFilter/localized.js";
import "../../../components/filter/dateRangeFilter/DateRangeHistoricalFilter.js";
import "../../../components/filter/MultiStepFilterApplyButton.js";
import "../../../components/filter/MultiStepFilterInput.js";
import "../../../components/filter/MultiStepFilterHoc.js";
import "../../../components/select/selectStyle.js";
import "../../../components/select/MultiSelectFooter.js";
import "../../../components/select/MultiSelect.js";
import "../../../components/select/MultiSelectItem.js";
import "../../../components/select/SelectArrowIcon.js";
import "../../../components/select/VirtualizedMultiSelectOptionList.js";
import "../../../components/select/SingleSelect.js";
import "../../../components/select/MultiSelectWithExclude.js";
import "../../../components/select/MultiSelectTextCounterWithTooltip.js";
import "../../../components/filter/PhoneFilter.js";
import "../../brand-license/constants.js";
import "../../country/components/CountryFilter.js";
import "../../brand-license/components/BrandProvider.js";
import "react-oidc-context";
import "oidc-client-ts";
import "../../../components/alerts/NoAccessInfoMessage.js";
import "../../brand-license/components/LicenseSelect.js";
import "../../brand-license/components/BrandSelect.js";
import "../../../components/circle-box/CircleBoxWithText.js";
import "../../../components/label/EmptyLabel.js";
import "../../../components/label/LabelHoc.js";
import "../../../components/tooltip/Tooltip.js";
import "../../../components/tooltip/AutoAdjustedWidthTooltip.styles.js";
import "../../../components/tooltip/AutoAdjustedComplexTooltip.styles.js";
import "../../../components/tooltip/MultiLineAutoAdjustedWidthTooltip.js";
import "@mui/material/colors";
import "@mui/material/locale";
import "@mui/material/styles";
import "../../../style/hooks.js";
import "../../../components/circle-box/CircleBox.js";
import "../../user-profile/components/Filters.js";
import "../../user-profile/components/P2PStatusCell.js";
import "../../user-profile/components/UserDetailsWDBalance.js";
import "../../user-profile/components/ReferralLinkButton.js";
import "../../user-profile/components/PlayerIdAutocomplete.js";
import { BulkTransactionP2PTransferExecutionStepModal } from "./BulkExecutionStepModal.js";
import { BulkTransactionP2PTransferApplyStepModal } from "./BulkP2PTransferApplyStepModal.js";
import { BulkTransactionP2PTransferUploadStepModal } from "./BulkP2PTransferUploadStepModal.js";
import { BulkTransactionP2PTransferValidationStepModal } from "./BulkP2PTransferValidationStepModal.js";
import { BulkTransactionP2PTransferSummaryStepModal } from "./BulkSummaryStepModal.js";
const localized = defineMessages({
  p2pTransfer: {
    id: "BulkP2PTransferButton_label",
    defaultMessage: "P2P Transfer"
  },
  p2pTransferViaFile: {
    id: "BulkP2PTransferViaFileButton_label",
    defaultMessage: "Bulk Transfer via CSV"
  }
});
function useBulkP2PTransferAccess({
  p2pSettingsEntityType,
  agentUid
}) {
  const { item } = useUserProfileDetails({
    viewType: "P2PTransfer",
    fields: ["uid", "p2p_override_status", "p2p_status"],
    id: agentUid,
    cleanDelay: extendedViewCleanDelay
  });
  const { item: settings } = useP2PPlayerSettings({
    uid: item?.uid,
    entityType: p2pSettingsEntityType,
    viewType: "P2PTransfer",
    fields: ["global_settings.is_p2p_locked"],
    validateFilter: () => !item?.p2p_override_status
  });
  return {
    p2pTransferLocked: item?.p2p_override_status ? item?.p2p_status !== FeatureAccessStatus.Unlocked : settings?.global_settings?.is_p2p_locked
  };
}
function BulkP2PTransferButton({
  uids,
  agentUid,
  p2pSettingsEntityType,
  bulkOperationEntityType,
  loadP2PTransfersStrategy,
  applyP2PTransfersStrategy,
  validationP2PTransferStrategy,
  performP2PTransfersStrategy,
  applyStepGridColumns,
  disabled
}) {
  const { p2pTransferLocked } = useBulkP2PTransferAccess({ agentUid, p2pSettingsEntityType });
  const { chooseStep, closeModal } = useContext(BulkModalContext);
  const request = { uids, keys: ["uid", "finance.balance", "username"] };
  const { resetBulkState } = useBulkAction({ strategy: loadP2PTransfersStrategy, request });
  const openApplyStep = () => chooseStep(applyStep, resetBulkState, void 0);
  const openValidation = () => chooseStep(validationStep, resetBulkState, void 0);
  const openChangesSummary = () => chooseStep(changesSummaryStep, resetBulkState, void 0);
  const openExecutionSummary = () => chooseStep(executionSummaryStep, resetBulkState, void 0);
  const applyStep = /* @__PURE__ */ React.createElement(
    BulkTransactionP2PTransferApplyStepModal,
    {
      onNext: openValidation,
      onPrev: closeModal,
      strategy: applyP2PTransfersStrategy,
      gridColumns: applyStepGridColumns
    }
  );
  const validationStep = /* @__PURE__ */ React.createElement(
    BulkTransactionP2PTransferValidationStepModal,
    {
      onNext: openChangesSummary,
      onPrev: openApplyStep,
      agentUid,
      strategy: validationP2PTransferStrategy
    }
  );
  const changesSummaryStep = /* @__PURE__ */ React.createElement(BulkTransactionP2PTransferSummaryStepModal, { onNext: openExecutionSummary, onPrev: closeModal, withFlexibleGrid: true });
  const executionSummaryStep = /* @__PURE__ */ React.createElement(
    BulkTransactionP2PTransferExecutionStepModal,
    {
      onNext: closeModal,
      hasRetry: true,
      withFlexibleGrid: true,
      bulkOperationEntityType,
      strategy: performP2PTransfersStrategy
    }
  );
  const handleClick = () => {
    resetBulkState();
    openApplyStep();
  };
  return /* @__PURE__ */ React.createElement(
    BulkActionButton,
    {
      disabled: disabled || p2pTransferLocked,
      label: localized.p2pTransfer,
      onClick: handleClick,
      color: "primary",
      itemsCount: uids?.length
    }
  );
}
function BulkP2PTransferViaFileButton({
  agentUid,
  p2pSettingsEntityType,
  bulkOperationEntityType,
  loadP2PTransfersStrategy,
  applyP2PTransfersStrategy,
  validationP2PTransferStrategy,
  performP2PTransfersStrategy,
  applyStepGridColumns,
  disabled
}) {
  const { p2pTransferLocked } = useBulkP2PTransferAccess({ agentUid, p2pSettingsEntityType });
  const { chooseStep, closeModal } = useContext(BulkModalContext);
  const { resetBulkState } = useBulkAction();
  const openUploadFileStep = () => chooseStep(uploadFileStep, resetBulkState, void 0);
  const openApplyStep = () => chooseStep(applyStep, resetBulkState, void 0);
  const openValidation = () => chooseStep(validationStep, resetBulkState, void 0);
  const openChangesSummary = () => chooseStep(changesSummaryStep, resetBulkState, void 0);
  const openExecutionSummary = () => chooseStep(executionSummaryStep, resetBulkState, void 0);
  const uploadFileStep = /* @__PURE__ */ React.createElement(BulkTransactionP2PTransferUploadStepModal, { onNext: openApplyStep, onPrev: closeModal, strategy: loadP2PTransfersStrategy });
  const applyStep = /* @__PURE__ */ React.createElement(
    BulkTransactionP2PTransferApplyStepModal,
    {
      onNext: openValidation,
      onPrev: closeModal,
      strategy: applyP2PTransfersStrategy,
      gridColumns: applyStepGridColumns
    }
  );
  const validationStep = /* @__PURE__ */ React.createElement(
    BulkTransactionP2PTransferValidationStepModal,
    {
      onNext: openChangesSummary,
      onPrev: openApplyStep,
      agentUid,
      strategy: validationP2PTransferStrategy
    }
  );
  const changesSummaryStep = /* @__PURE__ */ React.createElement(BulkTransactionP2PTransferSummaryStepModal, { onNext: openExecutionSummary, onPrev: closeModal, withFlexibleGrid: true });
  const executionSummaryStep = /* @__PURE__ */ React.createElement(
    BulkTransactionP2PTransferExecutionStepModal,
    {
      onNext: closeModal,
      hasRetry: true,
      withFlexibleGrid: true,
      bulkOperationEntityType,
      strategy: performP2PTransfersStrategy
    }
  );
  function handleClick() {
    resetBulkState();
    openUploadFileStep();
  }
  return /* @__PURE__ */ React.createElement(OutlinedButton, { disabled: disabled || p2pTransferLocked, label: localized.p2pTransferViaFile, onClick: handleClick });
}
export {
  BulkP2PTransferButton,
  BulkP2PTransferViaFileButton
};
//# sourceMappingURL=BulkP2PTransferButton.js.map
